import ReportStockValue from "../../../../components/@reports/inventory/ReportStockValue";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/inventory/stockValueSchema"

export default function StockValueReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.inventory}
            reportType={reportTypes.inventory.stockValue.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportStockValue
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       